export var HTMLCanvasElement = Object;
//# sourceMappingURL=HTMLCanvasElement.js.map